import React from "react";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";


import { useState } from "react";
import "../designcss/Faq.css";

const faqData = [
  {
    id: 1,
    question: "What is WoSender?",
    answer:
      "WoSender is a full-fledged whatsapp marketing software that assists business to conduct targeted campaigns, automated messaging, and customer engagement in WhatsApp.",
  },
  {
    id: 2,
    question: "What is the way to use WoSender to benefit my business?",

    answer:
      "Through the whatsapp marketing services of WoSender, you are able to send personal messages in bulk, automate responses, segment contacts and monitor campaign performance that ensures better engagement and sales.",
  },
  {
    id: 3,
    question: "Does WoSender require some easy usage by beginners?",
    answer:
      "Yes! WoSender is designed with easy-to-use interface to enable both the big and small businesses to design and run the WhatsApp campaign without prior technical knowledge.",
  },
  {
    id: 4,
    question: " Is it possible to schedule messages using this tool?",
    answer:
      "Yes - WoSender provides the possibility to plan campaigns beforehand to deliver messages at the appropriate time and to make a maximum impact.",
  },

  {
    id: 5,
    question: "What type of coding knowledge is required to use WoSender?",
    answer:
      "No. WoSenders whatsapp marketing software is easy to use and does not need any code to create and execute the robust campaigns.",
  },
];

const FAQ = () => {
  const [openId, setOpenId] = useState(1);

  const toggleFAQ = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <div className="qr-faq-wrapper">
  <div className="qr-faq-container">
    <h2 className="qr-faq-heading">Frequently Asked Questions</h2>

    {faqData.map((item) => (
      <div
        key={item.id}
        className={`qr-faq-card ${openId === item.id ? "active" : ""}`}
        onClick={() => toggleFAQ(item.id)}
      >
        <div className="qr-faq-question">
          <span className="qr-faq-arrow">
            {openId === item.id ? (
              <IoIosArrowDown size={18} />
            ) : (
              <IoIosArrowUp size={18} />
            )}
          </span>
          <p>{item.question}</p>
        </div>

        {openId === item.id && (
          <div className="qr-faq-answer">
            <p>{item.answer}</p>
          </div>
        )}
      </div>
    ))}
  </div>
</div>

  );
};

export default FAQ;
